import { useState,useEffect,useRef } from 'react';
import styles from './TaskAdd.module.css';
import useApi from '../../services/useApi';

const Spinner = ({ size = 16, color = 'white' }) => {
    const strokeWidth=size/4;
    const radius=20;
    const viewBoxSize=50;

    return (
        <svg
          width={size}
          height={size}
          viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
          className={styles['spinner']}
        >
          <circle
            cx="25"
            cy="25"
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={Math.PI * radius * 0.2}
            strokeDashoffset="0"
          />
        </svg>
    );
};

export default function TaskAdd({onChange,onClose}){
    const [uploadErr,setUploadErr] = useState(false);
    const [uploadMsg,setUploadMsg]=useState("");
    const inputRef=useRef(null);
    const [inputValue,setInputValue]=useState('');
    const [searchStatus,setSearchStatus]=useState('do');

    useEffect(()=>{
        if(!inputRef.current)return;
        inputRef.current.focus();

        const handleInputKeyDown=(e)=>{
            if(e.key ==='Escape'){
                onClose();
            }
        }

        document.addEventListener("keydown", handleInputKeyDown);
        return () => {
            document.removeEventListener("keydown", handleInputKeyDown);
        };
    },[])

    useEffect(()=>{
        if(inputValue===null||inputValue===''){
            setSearchStatus('do')
            return;
        }

        setSearchStatus('doing')
        const handler=setTimeout(()=>{
            useApi.get('backboard/model/playground/flcore/'+inputValue+'/rounds').then((res)=>{
                if(res.data.data){
                    setSearchStatus('done')
                    onChange(inputValue)
                }else{
                    setSearchStatus('fail')
                }
            }).catch(function (thrown) {
                setSearchStatus('fail')
            });
        },150)

        return()=>{
            clearTimeout(handler);
        }
    },[inputValue])

    useEffect(()=>{
        if(searchStatus==='done'||searchStatus==='fail'){
            if(inputValue===null||inputValue===''){
                setSearchStatus('do');
            }
        }

    },[searchStatus])

    const handleInputChange=(event)=>{
        if(event.key==='Escape')onClose();
        setInputValue(event.target.value);
    }

    useEffect(()=>{
        let timer;
        if(uploadErr){
            timer=setTimeout(() => {
                setUploadErr(false);
            }, 1200);
        }
        return()=>{
            clearTimeout(timer);
        }
    },[uploadErr])
    
    return(
        <div className={styles['main']}>
            <div className={styles['body']}>
                {searchStatus==='doing'?
                <Spinner/>
                :
                <div className={`
                    ${styles['status']}
                    ${styles['status-' + searchStatus]}
                `}/>}
                <input 
                ref={inputRef}
                placeholder='Task ID를 입력해 주세요.'
                value={inputValue}
                onChange={handleInputChange} 
                />
                {inputValue!==''&&<button 
                className={styles['input-clear']}
                onClick={()=>setInputValue('')}/>}

            </div>
        </div>
    )
}